<template>
  <div class="mt-4">
    <v-row class="fill-height justify-center">
      <v-col>
        <v-form
          ref="form"
          lazy-validation
          @keydown.enter="submit"
          @submit.prevent="submit"
          class="py-4"
        >
          <div class="d-flex flex-column">
            <div class="d-flex flex-row">
              <div class="flex-grow-1">
                <v-autocomplete
                  id="date-options"
                  v-model="model.dateOption"
                  :items="dateOptionItems"
                  filled
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  label="Date Options"
                  hide-details
                  :disabled="$route.path === '/monitor'"
                ></v-autocomplete>
                <div
                  class="pa-4 pb-0 pt-4 mb-4"
                  style="border: 1px solid #4c4b48; border-top: none"
                >
                  <div
                    class="d-flex flex-column"
                    v-if="model.dateOption === 'seasonal'"
                  >
                    <v-radio-group v-model="model.seasonal.type" class="mt-0">
                      <template v-slot:label>
                        <div>Type</div>
                      </template>
                      <v-radio value="collect_month">
                        <template v-slot:label>
                          <v-container
                            class="
                              d-flex
                              justify-space-between
                              align-center
                              ma-0
                              pa-0
                            "
                            fluid
                          >
                            <span>Choose months</span>
                            <tooltip-modal class_def="pl-2">
                              Select imagery collected within any of the chosen
                              months of any year
                            </tooltip-modal>
                          </v-container>
                        </template>
                      </v-radio>

                      <v-radio value="collect_month_day_between">
                        <template v-slot:label>
                          <v-container
                            class="
                              d-flex
                              justify-space-between
                              align-center
                              ma-0
                              pa-0
                            "
                            fluid
                          >
                            <span>Date range</span>
                            <tooltip-modal class_def="pl-2">
                              Select imagery collected between the specified
                              date range of any year
                            </tooltip-modal>
                          </v-container>
                        </template>
                      </v-radio>
                      <v-radio value="collect_month_day_or">
                        <template v-slot:label>
                          <v-container
                            class="
                              d-flex
                              justify-space-between
                              align-center
                              ma-0
                              pa-0
                            "
                            fluid
                          >
                            <span>Before and after</span>
                            <tooltip-modal class_def="pl-2">
                              Select imagery collected before the first
                              month/day and after the second month/day of any
                              year
                            </tooltip-modal>
                          </v-container>
                        </template>
                      </v-radio>
                      <v-radio value="collect_day">
                        <template v-slot:label>
                          <v-container
                            class="
                              d-flex
                              justify-space-between
                              align-center
                              ma-0
                              pa-0
                            "
                            fluid
                          >
                            <span>Between days in a month</span>
                            <tooltip-modal class_def="pl-2">
                              Select imagery collected between the chosen days
                              on any month/year
                            </tooltip-modal>
                          </v-container>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div class="mt-4">
                      <div
                        v-if="model.seasonal.type === 'collect_month'"
                        class="d-flex flex-row"
                      >
                        <v-autocomplete
                          id="months"
                          v-model="model.seasonal.months"
                          :items="months"
                          item-text="label"
                          item-value="value"
                          multiple
                          outlined
                          dense
                          label="Months"
                          :rules="seasonalMonthRules"
                          hint="Required"
                          persistent-hint
                        >
                        </v-autocomplete>
                      </div>
                      <div
                        v-else-if="
                          model.seasonal.type === 'collect_month_day_between'
                        "
                      >
                        <div class="d-flex flex-grow-1">
                          <v-row no-gutters>
                            <v-col cols="4">
                              <span class="text--secondary"> Start </span>
                            </v-col>
                            <v-col cols="8">
                              <v-row no-gutters>
                                <v-col cols="8">
                                  <v-autocomplete
                                    id="start-month"
                                    v-model="model.seasonal.between.start.month"
                                    :items="months"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    dense
                                    label="Month"
                                    :rules="seasonalStartMonthRules"
                                    hint="Required"
                                    persistent-hint
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    id="seasonal-start-date-field"
                                    v-model="model.seasonal.between.start.date"
                                    filled
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="31"
                                    label="Date"
                                    class="pl-2"
                                    :rules="seasonalStartDateRules"
                                    hint="Required"
                                    persistent-hint
                                  /> </v-col
                              ></v-row>
                            </v-col>
                          </v-row>
                        </div>
                        <div class="d-flex flex-grow-1">
                          <v-row no-gutters>
                            <v-col cols="4">
                              <span class="text--secondary"> End </span>
                            </v-col>
                            <v-col cols="8">
                              <v-row no-gutters>
                                <v-col cols="8">
                                  <v-autocomplete
                                    id="end-month"
                                    v-model="model.seasonal.between.end.month"
                                    :items="months"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    dense
                                    label="Month"
                                    :rules="seasonalEndMonthRules"
                                    hint="Required"
                                    persistent-hint
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    id="seasonal-end-date-field"
                                    v-model="model.seasonal.between.end.date"
                                    filled
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="31"
                                    label="Date"
                                    class="pl-2"
                                    :rules="seasonalEndDateRules"
                                    hint="Required"
                                    persistent-hint
                                  /> </v-col
                              ></v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          model.seasonal.type === 'collect_month_day_or'
                        "
                      >
                        <div class="d-flex flex-grow-1">
                          <v-row no-gutters>
                            <v-col cols="4">
                              <span class="text--secondary"> Before </span>
                            </v-col>
                            <v-col cols="8">
                              <v-row no-gutters>
                                <v-col cols="8">
                                  <v-autocomplete
                                    id="before-month"
                                    v-model="model.seasonal.or.lt.month"
                                    :items="months"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    dense
                                    label="Month"
                                    :rules="seasonalOrBeforeMonthRules"
                                    hint="Required"
                                    persistent-hint
                                    class="mr-2"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    id="before-month-field"
                                    v-model="model.seasonal.or.lt.date"
                                    filled
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="31"
                                    label="Date"
                                    :rules="seasonalOrBeforeDateRules"
                                    hint="Required"
                                    persistent-hint
                                  /> </v-col
                              ></v-row>
                            </v-col>
                          </v-row>
                        </div>
                        <div class="d-flex flex-grow-1">
                          <v-row no-gutters>
                            <v-col cols="4">
                              <span class="text--secondary text--caption">
                                After
                              </span>
                            </v-col>
                            <v-col cols="8">
                              <v-row no-gutters>
                                <v-col cols="8">
                                  <v-autocomplete
                                    id="after-month"
                                    v-model="model.seasonal.or.gt.month"
                                    :items="months"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    dense
                                    label="Month"
                                    :rules="seasonalOrAfterMonthRules"
                                    hint="Required"
                                    persistent-hint
                                    class="mr-2"
                                  ></v-autocomplete>
                                </v-col>

                                <v-col cols="4">
                                  <v-text-field
                                    id="after-month-field"
                                    v-model="model.seasonal.or.gt.date"
                                    filled
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="31"
                                    label="Date"
                                    :rules="seasonalOrAfterDateRules"
                                    hint="Required"
                                    persistent-hint
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <div
                        v-else-if="model.seasonal.type === 'collect_day'"
                        class="d-flex justify-space-between"
                      >
                        <div class="d-flex flex-grow-1">
                          <v-text-field
                            id="start-day-field"
                            v-model="model.seasonal.days_between.start"
                            filled
                            outlined
                            dense
                            type="number"
                            min="1"
                            max="31"
                            label="Start Day"
                            class="pl-2"
                            :rules="seasonalDaysBetweenStartRules"
                            hint="Required"
                            persistent-hint
                          />
                        </div>
                        <div class="d-flex flex-grow-1">
                          <v-text-field
                            id="end-day-field"
                            v-model="model.seasonal.days_between.end"
                            filled
                            outlined
                            dense
                            type="number"
                            min="1"
                            max="31"
                            label="End Day"
                            class="pl-2"
                            :rules="seasonalDaysBetweenEndRules"
                            hint="Required"
                            persistent-hint
                          />
                        </div>
                      </div>

                      <div class="mb-4" v-if="$route.path !== '/monitor'">
                        <v-switch
                          id="seasonal-years-between-switch"
                          v-model="model.seasonal.years_between.enabled"
                          dense
                          style="margin-top: 0"
                        >
                          <template v-slot:label>
                            <v-container
                              class="
                                d-flex
                                justify-space-between
                                align-center
                                ma-0
                                pa-0
                              "
                              fluid
                            >
                              <span>Year range</span>
                              <tooltip-modal class_def="pl-2">
                                Include start year and end year range to select
                                imagery from
                              </tooltip-modal>
                            </v-container></template
                          >
                        </v-switch>
                        <div
                          v-if="model.seasonal.years_between.enabled"
                          class="d-flex justify-space-between mt-2"
                        >
                          <div class="d-flex flex-grow-1">
                            <v-text-field
                              id="start-year-field"
                              v-model="model.seasonal.years_between.start"
                              filled
                              outlined
                              dense
                              type="number"
                              min="1"
                              max="2100"
                              label="Start Year"
                              class="pl-2"
                              :rules="seasonalYearsBetweenStartRules"
                              hint="Required without End Year"
                              persistent-hint
                            />
                          </div>
                          <div class="d-flex flex-grow-1">
                            <v-text-field
                              id="end-year-field"
                              v-model="model.seasonal.years_between.end"
                              filled
                              outlined
                              dense
                              type="number"
                              min="1"
                              max="2100"
                              label="End Year"
                              class="pl-2"
                              :rules="seasonalYearsBetweenEndRules"
                              hint="Required without Start Year"
                              persistent-hint
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="model.dateOption === 'datetime'" class="mt-2">
                    <div class="d-flex flex-grow-1">
                      <v-text-field
                        id="start-date-field"
                        v-model="model.startDate"
                        filled
                        outlined
                        :rules="startDateRules"
                        type="date"
                        label="Start Date"
                      />
                      <tooltip-modal class_def="pb-6 pl-2 pr-0">
                        Select imagery collected on or after this date
                      </tooltip-modal>
                    </div>

                    <div class="d-flex">
                      <v-text-field
                        id="end-date-field"
                        v-model="model.endDate"
                        filled
                        outlined
                        :rules="endDateRules"
                        type="date"
                        label="End Date"
                      />
                      <tooltip-modal class_def="pb-6 pl-2 pr-0">
                        Select imagery collected on or before this date
                      </tooltip-modal>
                    </div>
                    <div class="mb-4">
                      <v-switch
                        id="start-end-date-image-categories-switch"
                        v-model="model.datetime.image_age_categories.enabled"
                        dense
                        style="margin-top: 0"
                        class="mb-2"
                      >
                        <template v-slot:label>
                          <v-container
                            class="
                              d-flex
                              justify-space-between
                              align-center
                              ma-0
                              pa-0
                            "
                            fluid
                          >
                            <span>Image Age Categories</span>
                            <tooltip-modal class_def="pb-0 pl-2">
                              <span class="text--secondary"
                                >Image Age Category:</span
                              >
                              allows filtering between Fresh, Standard and
                              Training categories
                            </tooltip-modal>
                          </v-container></template
                        >
                      </v-switch>

                      <div
                        class="d-flex"
                        v-if="model.datetime.image_age_categories.enabled"
                      >
                        <v-autocomplete
                          id="image-categories"
                          v-model="model.imageCategories"
                          :items="imageCategoryItems"
                          item-text="label"
                          item-value="value"
                          multiple
                          outlined
                          dense
                          label="Choose categories"
                          hide-details
                        >
                        </v-autocomplete>
                        <tooltip-modal class_def="pb-0 pl-2">
                          <span class="text--secondary">Fresh:</span> imagery 90
                          days or newer <br />
                          <span class="text--secondary">Standard:</span> between
                          90 days and three years old<br />
                          <span class="text--secondary">Training:</span> imagery
                          older than three years<br />
                        </tooltip-modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-grow-0">
                <tooltip-modal class_def="py-2 px-2">
                  <span class="text--secondary"
                    >Date Range And/Or Image Age Categories:</span
                  >
                  filter between a start date, end date, &amp;/or Fresh,
                  Standard and Training categories<br />
                  <span class="text--secondary">Seasonal:</span> allows
                  filtering of certain months or between certain dates in a
                  calendar year<br />
                </tooltip-modal>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <v-autocomplete
              id="sensors"
              v-model="model.sensors"
              :items="sensorItems"
              item-text="label"
              item-value="value"
              label="Sensors"
              multiple
              outlined
              dense
            ></v-autocomplete>
            <tooltip-modal>
              Specifies which sensors/satellites to search for imagery from.
            </tooltip-modal>
          </div>

          <div class="d-flex" v-if="$route.path !== '/monitor'">
            <v-switch
              id="maximum-stack-depth-switch"
              v-model="model.stackDepthLimit"
              dense
              style="margin-top: 4px"
              label="Stack Depth Limit"
              class="mr-4"
              @change="onStackDepthLimitToggle"
            >
            </v-switch>

            <v-text-field
              ref="stackDepthInput"
              v-if="model.stackDepthLimit"
              id="stack-depth-field"
              v-model="model.stackDepth"
              filled
              outlined
              dense
              :rules="validators.stackDepth"
              type="number"
            />
            <v-text-field
              v-else
              id="no-stack-depth-field"
              filled
              outlined
              dense
              :readonly="true"
              value="Unlimited Stack Depth"
            ></v-text-field>
            <tooltip-modal v-if="model.stackDepthLimit">
              Limit the maximum number of tiles per cell to return.
            </tooltip-modal>
            <tooltip-modal v-else>
              No limit on the number of tiles per cell to return.
            </tooltip-modal>
          </div>

          <div class="d-flex mt-0 mb-4" v-if="is_internal">
            <div class="flex-grow-1">
              <v-switch
                id="3d-switch"
                v-model="model.p3dr_support"
                dense
                style="margin-top: 4px"
                label="P3DR Support"
              >
              </v-switch>
            </div>
            <div class="">
              <tooltip-modal class_def="px-2 pt-2">
                Limit tiles to those that have P3DR (Precision 3D Registration)
                support
              </tooltip-modal>
            </div>
          </div>

          <div class="d-flex mt-2 mb-4">
            <div class="flex-grow-1">
              <v-switch
                id="hd-switch"
                v-model="model.hd_support"
                dense
                style="margin-top: 4px"
                label="HD Support"
              >
              </v-switch>
            </div>
            <div class="">
              <tooltip-modal class_def="px-2 py-2">
                Limit tiles to those that have HD (High Definition) support
              </tooltip-modal>
            </div>
          </div>

          <div class="d-flex">
            <v-text-field
              id="cloud-cover-field"
              v-model="model.maxCloudCover"
              filled
              outlined
              dense
              :rules="validators.maxCloudCover"
              type="number"
              label="Max Cloud Cover %"
              suffix="%"
            />
            <tooltip-modal>
              The maximum percentage of the tile area covered by clouds.
            </tooltip-modal>
          </div>

          <div class="d-flex">
            <v-text-field
              id="data-percent-field"
              v-model="model.minDataPercent"
              filled
              outlined
              dense
              :rules="validators.maxCloudCover"
              type="number"
              label="Min Data Percentage"
              suffix="%"
            />
            <tooltip-modal>
              The miniumum percentage of the cell area covered by imagery.
            </tooltip-modal>
          </div>

          <div class="d-flex">
            <v-text-field
              id="max-off-nadir-field"
              v-model="model.maxOffNadir"
              filled
              outlined
              dense
              :rules="validators.zeroToNinety"
              type="number"
              label="Max Off Nadir"
            />
            <tooltip-modal>
              The satelitte's angle in relation to the image at the time of
              collection.
            </tooltip-modal>
          </div>

          <div class="d-flex">
            <v-text-field
              id="min-sun-elevation-field"
              v-model="model.minSunElevation"
              filled
              outlined
              dense
              :rules="validators.zeroToNinety"
              type="number"
              label="Min Sun Elevation"
            />
            <tooltip-modal>
              The angular height of the sun at the time of collection.
            </tooltip-modal>
          </div>

          <div class="d-flex">
            <v-text-field
              id="select-name-field"
              v-model="model.name"
              filled
              outlined
              dense
              type="text"
              :label="`${
                $route.path === '/monitor' ? 'Monitor' : 'Select'
              } Name`"
            />
            <tooltip-modal>
              Named
              {{ $route.path === "/monitor" ? "monitors" : "selects" }}
              are easier to lookup and do not expire
            </tooltip-modal>
          </div>

          <div class="d-flex" v-if="$route.path === '/monitor'">
            <v-textarea
              id="description-area"
              v-model="model.description"
              filled
              outlined
              dense
              label="Description"
              :rules="descriptionRules"
              @input="$refs.form.validate()"
              clearable
            />
            <tooltip-modal> Monitor description </tooltip-modal>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validators from "@/utils/validators";
import TooltipModal from "@/components/shared/TooltipModal";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  mixins: [validators],
  props: {
    defaultModel: {
      type: Object,
      default: () => {
        return {
          stackDepth: 5,
          stackDepthLimit: true,
          p3dr_support: false,
          hd_support: false,
          maxCloudCover: 10,
          startDate: null,
          endDate: null,
          imageCategories: [],
          minDataPercent: 85,
          maxOffNadir: 30,
          minSunElevation: 5,
          sensors: [
            { label: "GeoEye-1", value: "geoeye-01" },
            { label: "Worldview-2", value: "worldview-02" },
            { label: "Worldview-3", value: "worldview-03" },
            { label: "Worldview-4", value: "worldview-04" },
          ],
          dateOption: "datetime",
          image_age_category: {
            range: {
              enabled: false,
            },
          },
          datetime: {
            image_age_categories: {
              enabled: false,
            },
          },
          seasonal: {
            type: "collect_month",
            months: [
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
              "09",
              "10",
              "11",
              "12",
            ],
            between: {
              start: {
                month: null,
                date: 1,
              },
              end: {
                month: null,
                date: 1,
              },
            },
            or: {
              lt: {
                month: null,
                date: 1,
              },
              gt: {
                month: null,
                date: 1,
              },
            },
            days_between: {
              start: null,
              end: null,
            },
            years_between: {
              enabled: false,
              start: new Date().getFullYear(),
              end: new Date().getFullYear() + 1,
            },
          },
          name: "",
          description: "",
        };
      },
    },
    select: {},
  },
  components: {
    TooltipModal,
  },
  data() {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const imageCategories = this.getImageCategories();
    const months = this.getCollectMonths();
    const between = this.getCollectMonthDayBetween();
    const or = this.getCollectMonthDayOr();
    const days_between = this.getCollectDaysBetween();
    const years_between = this.getCollectYearsBetween();

    const dateOption =
      this.$route.path === "/monitor"
        ? "seasonal"
        : imageCategories.length > 0 ||
          (!this.isValidYearsBetween(years_between) && (startDate || endDate))
        ? "datetime"
        : (Array.isArray(months) && months.length > 0) ||
          this.isValidDateRange(between) ||
          this.isValidBeforeAfter(or) ||
          this.isValidDaysBetween(days_between)
        ? "seasonal"
        : this.defaultModel.dateOption;
    const type = this.isValidDateRange(between)
      ? "collect_month_day_between"
      : this.isValidBeforeAfter(or)
      ? "collect_month_day_or"
      : this.isValidDaysBetween(days_between)
      ? "collect_day"
      : this.defaultModel.seasonal.type;

    return {
      model: {
        stackDepth: this.select?.stack_depth || this.defaultModel.stackDepth,
        stackDepthLimit: this.select
          ? Number.isInteger(parseInt(this.select?.stack_depth))
            ? true
            : false
          : true,
        p3dr_support:
          this.select?.query["p3dr_support"]?.eq ||
          this.defaultModel.p3dr_support,
        hd_support: this.select
          ? this.select?.query["pan_resolution_avg"]?.gte == 0.4
            ? true
            : false
          : false,
        // this.defaultModel.hd_support,
        maxCloudCover:
          this.select?.query["tile:cloud_percentage"]?.lte ||
          this.defaultModel.maxCloudCover,
        startDate,
        endDate,
        imageCategories,
        minDataPercent:
          this.select?.query["tile:data_percentage"]?.gte ||
          this.defaultModel.minDataPercent,
        maxOffNadir:
          this.select?.query["view:off_nadir"]?.lte ||
          this.defaultModel.maxOffNadir,
        minSunElevation:
          this.select?.query["view:sun_elevation"]?.gte ||
          this.defaultModel.minSunElevation,
        sensors: this.getSensors(),
        dateOption,
        seasonal: {
          type,
          months: months || this.defaultModel.seasonal.months,
          between: between || this.defaultModel.seasonal.between,
          or: or || this.defaultModel.seasonal.or,
          days_between: days_between || this.defaultModel.seasonal.days_between,
          years_between:
            years_between || this.defaultModel.seasonal.years_between,
        },
        datetime: {
          image_age_categories: {
            enabled: imageCategories.length > 0,
          },
        },
      },
      sensorItems: [
        ...this.defaultModel.sensors,
        { label: "Worldview-1", value: "worldview-01" },
      ].sort((a, b) => a.label.localeCompare(b.label)),
      imageCategoryItems: [
        { label: "Fresh", value: "fresh" },
        { label: "Standard", value: "standard" },
        { label: "Training", value: "training" },
      ],
      dateOptionItems:
        this.$route.path === "/monitor"
          ? [{ label: "Seasonal", value: "seasonal" }]
          : [
              {
                label: "Date Range And/Or Image Age Categories",
                value: "datetime",
              },
              { label: "Seasonal", value: "seasonal" },
            ],
      months: [
        { label: "January", value: "01" },
        { label: "February", value: "02" },
        { label: "March", value: "03" },
        { label: "April", value: "04" },
        { label: "May", value: "05" },
        { label: "June", value: "06" },
        { label: "July", value: "07" },
        { label: "August", value: "08" },
        { label: "September", value: "09" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" },
      ],
    };
  },
  mounted() {
    this.$emit("mounted");
  },
  computed: {
    ...mapGetters(["account_details"]),

    is_internal() {
      if (this.account_details) {
        return this.account_details.internal;
      }
      return false;
    },
    startDateRules() {
      return [
        (v) =>
          (v && v !== this.model.endDate) || !v
            ? true
            : "Start Date and End Date cannot be the same date",
        (v) =>
          (v && !this.model.endDate) ||
          (v &&
            this.model.endDate &&
            new Date(v).getTime() < new Date(this.model.endDate).getTime()) ||
          !v
            ? true
            : "Start Date must be before End Date",
      ];
    },
    endDateRules() {
      return [
        (v) =>
          (v && v !== this.model.startDate) || !v
            ? true
            : "End Date and Start Date cannot be the same date",
        (v) =>
          (v && !this.model.startDate) ||
          (v &&
            this.model.startDate &&
            new Date(v).getTime() > new Date(this.model.startDate).getTime()) ||
          !v
            ? true
            : "End Date must be after Start Date",
      ];
    },
    seasonalMonthRules() {
      return [
        (v) => !!(v && v.length) || "At least one month must be selected",
      ];
    },
    seasonalStartMonthRules() {
      return [
        (v) => !!v || "Start Month required",
        (v) =>
          (v && !this.model.seasonal.between.end.month) ||
          (v &&
            this.model.seasonal.between.end.month &&
            parseInt(v) <= parseInt(this.model.seasonal.between.end.month)) ||
          !v
            ? true
            : "Start Month must be before End Month",
        (v) =>
          v &&
          this.model.seasonal.between.start.date &&
          this.model.seasonal.between.end.month &&
          this.model.seasonal.between.end.date &&
          this.convertToDate(
            v,
            this.model.seasonal.between.start.date
          ).getTime() >=
            this.convertToDate(
              this.model.seasonal.between.end.month,
              this.model.seasonal.between.end.date
            ).getTime()
            ? "Start Month/Date must be before End Month/Date"
            : true,
      ];
    },
    seasonalEndMonthRules() {
      return [
        (v) => !!v || "End Month required",
        (v) =>
          (v && !this.model.seasonal.between.start.month) ||
          (v &&
            this.model.seasonal.between.start.month &&
            parseInt(v) >= parseInt(this.model.seasonal.between.start.month)) ||
          !v
            ? true
            : "End Month must be after Start Month",
        (v) =>
          v &&
          this.model.seasonal.between.end.date &&
          this.model.seasonal.between.start.month &&
          this.model.seasonal.between.start.date &&
          this.convertToDate(
            v,
            this.model.seasonal.between.end.date
          ).getTime() <=
            this.convertToDate(
              this.model.seasonal.between.start.month,
              this.model.seasonal.between.start.date
            ).getTime()
            ? "End Month/Date must be after Start Month/Date"
            : true,
      ];
    },
    seasonalStartDateRules() {
      return [
        (v) => !!v || "Start Date required",
        (v) =>
          (parseInt(v) > 0 && parseInt(v) < 32) ||
          "Start Date must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.between.start.month &&
          this.model.seasonal.between.end.month &&
          this.model.seasonal.between.end.date &&
          this.convertToDate(
            this.model.seasonal.between.start.month,
            v
          ).getTime() >=
            this.convertToDate(
              this.model.seasonal.between.end.month,
              this.model.seasonal.between.end.date
            ).getTime()
            ? "Start Month/Date must be before End Month/Date"
            : true,
      ];
    },
    seasonalEndDateRules() {
      return [
        (v) => !!v || "End Date required",
        (v) =>
          (parseInt(v) > 0 && parseInt(v) < 32) ||
          "End Date must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.between.end.month &&
          this.model.seasonal.between.start.month &&
          this.model.seasonal.between.start.date &&
          this.convertToDate(
            this.model.seasonal.between.end.month,
            v
          ).getTime() <=
            this.convertToDate(
              this.model.seasonal.between.start.month,
              this.model.seasonal.between.start.date
            ).getTime()
            ? "End Month/Date must be after Start Month/Date"
            : true,
      ];
    },

    seasonalOrBeforeMonthRules() {
      return [
        (v) => !!v || "Before Month required",
        (v) =>
          (v && !this.model.seasonal.or.gt.month) ||
          (v &&
            this.model.seasonal.or.gt.month &&
            parseInt(v) <= parseInt(this.model.seasonal.or.gt.month)) ||
          !v
            ? true
            : "Before Month must be before After Month",
        (v) =>
          v &&
          this.model.seasonal.or.lt.date &&
          this.model.seasonal.or.gt.month &&
          this.model.seasonal.or.gt.date &&
          this.convertToDate(v, this.model.seasonal.or.lt.date).getTime() >=
            this.convertToDate(
              this.model.seasonal.or.gt.month,
              this.model.seasonal.or.gt.date
            ).getTime()
            ? "Before Month/Date must be before After Month/Date"
            : true,
      ];
    },

    seasonalOrAfterMonthRules() {
      return [
        (v) => !!v || "After Month required",
        (v) =>
          (v && !this.model.seasonal.or.lt.month) ||
          (v &&
            this.model.seasonal.or.lt.month &&
            parseInt(v) >= parseInt(this.model.seasonal.or.lt.month)) ||
          !v
            ? true
            : "After Month must be after Before Month",
        (v) =>
          v &&
          this.model.seasonal.or.gt.date &&
          this.model.seasonal.or.lt.month &&
          this.model.seasonal.or.lt.date &&
          this.convertToDate(v, this.model.seasonal.or.gt.date).getTime() <=
            this.convertToDate(
              this.model.seasonal.or.lt.month,
              this.model.seasonal.or.lt.date
            ).getTime()
            ? "After Month/Date must be after Before Month/Date"
            : true,
      ];
    },

    seasonalOrBeforeDateRules() {
      return [
        (v) => !!v || "Date required",
        (v) => (v > 0 && v < 32) || "Date must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.or.lt.month &&
          this.model.seasonal.or.gt.month &&
          this.model.seasonal.or.gt.date &&
          this.convertToDate(this.model.seasonal.or.lt.month, v).getTime() >=
            this.convertToDate(
              this.model.seasonal.or.gt.month,
              this.model.seasonal.or.gt.date
            ).getTime()
            ? "Before Month/Date must be before After Month/Date"
            : true,
      ];
    },
    seasonalOrAfterDateRules() {
      return [
        (v) => !!v || "After Date required",
        (v) => (v > 0 && v < 32) || "After Date must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.or.gt.month &&
          this.model.seasonal.or.lt.month &&
          this.model.seasonal.or.lt.date &&
          this.convertToDate(this.model.seasonal.or.gt.month, v).getTime() <=
            this.convertToDate(
              this.model.seasonal.or.lt.month,
              this.model.seasonal.or.lt.date
            ).getTime()
            ? "After Month/Date must be after Before Month/Date"
            : true,
      ];
    },

    seasonalDaysBetweenStartRules() {
      return [
        (v) => !isNaN(v) || "Start Day required",
        (v) => (v > 0 && v < 32) || "Start Day must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.days_between.end &&
          parseInt(v) > parseInt(this.model.seasonal.days_between.end)
            ? "Start Day must be before or equal to End Day"
            : true,
      ];
    },

    seasonalDaysBetweenEndRules() {
      return [
        (v) => !isNaN(v) || "End Day required",
        (v) => (v > 0 && v < 32) || "End Day must be between 1 and 31",
        (v) =>
          v &&
          this.model.seasonal.days_between.start &&
          parseInt(v) < parseInt(this.model.seasonal.days_between.start)
            ? "End Day must be after or equal to Start Day"
            : true,
      ];
    },

    seasonalYearsBetweenStartRules() {
      return [
        (v) =>
          /*
            must parseInt since isNaN(null) and isNaN('') are both false
            so if parseInt(null) and parseInt('') both return NaN 
          */
          isNaN(parseInt(v)) &&
          isNaN(parseInt(this.model.seasonal.years_between.end))
            ? "Start Year or End Year required"
            : true,
        (v) =>
          Number.isInteger(v) && v <= 0 && v > 2100
            ? "Start Year must be between 1 and 2099"
            : true,
        (v) =>
          v &&
          this.model.seasonal.years_between.end &&
          parseInt(v) >= parseInt(this.model.seasonal.years_between.end)
            ? "Start Year must before End Year"
            : true,
      ];
    },

    seasonalYearsBetweenEndRules() {
      return [
        (v) =>
          /*
            must parseInt since isNaN(null) and isNaN('') are both false
            so if parseInt(null) and parseInt('') both return NaN 
          */
          isNaN(parseInt(v)) &&
          isNaN(parseInt(this.model.seasonal.years_between.start))
            ? "End Year or Start Year required"
            : true,
        (v) =>
          Number.isInteger(v) && v <= 0 && v > 2100
            ? "End Year must be between 1 and 2099"
            : true,
        (v) =>
          v &&
          this.model.seasonal.years_between.start &&
          parseInt(v) <= parseInt(this.model.seasonal.years_between.start)
            ? "End Year must be after Start Year"
            : true,
      ];
    },

    seasonalStartDate() {
      return this.convertToDate(
        this.model.seasonal.between.start.month,
        this.model.seasonal.between.start.date
      );
    },
    seasonalEndDate() {
      return this.convertToDate(
        this.model.seasonal.between.end.month,
        this.model.seasonal.between.end.date
      );
    },
    descriptionRules() {
      return [
        (v) =>
          !v ||
          v.length <= 1024 ||
          "Description must have 1,024 characters or less",
      ];
    },
  },
  watch: {
    model: {
      deep: true,
      handler(newVal, oldVal) {
        // console.log(`model change=${JSON.stringify(newVal)}`);
        setTimeout(
          (() => {
            // find all invalid inputs using this method
            // since the form.value field that supposedly
            // states if the form is valid doesn't seem to
            // work with more complex rules like the
            // startDateRules and endDateRules within this
            // component
            const invalidInputs = this.$refs.form.inputs.filter(
              (input) => !input.valid
            );

            this.$emit("change", newVal, {
              // valid: this.$refs.form.value, // form.value signifies form validity, commented out since it doesn't work with the startDateRules/endDateRules
              valid: invalidInputs.length === 0,
              dirty:
                JSON.stringify(newVal) !== JSON.stringify(this.defaultModel),
            });
          }).bind(this),
          50
        );
      },
    },
  },
  methods: {
    onStackDepthLimitToggle(limit) {
      if (limit) {
        this.$nextTick(() => {
          const el = this.$refs.stackDepthInput.$el;
          if (el) {
            el.getElementsByTagName("input")[0].select();
          }
        });
      }
    },

    reset() {
      this.$refs.form.reset();

      /* need to give time for form to reset then reset values back to defaults */
      this.$nextTick(() => {
        this.model = { ...this.defaultModel };
      });
    },

    getStartDate() {
      if (this.select?.datetime) {
        const startDate = this.select?.datetime.split("/")[0];

        // make sure start date isn't a seasonal start year
        if (startDate != ".." && isNaN(Number(startDate))) {
          return startDate;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    getEndDate() {
      if (this.select?.datetime) {
        const endDate = this.select?.datetime.split("/")[1];

        // make sure end date isn't a seasonal end year
        if (endDate != ".." && isNaN(Number(endDate))) {
          return endDate;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    getSensors() {
      if (this.select?.query?.platform?.in) {
        var sensors = [...this.defaultModel.sensors];
        // wv-1 isnt default so add it here
        sensors.push({ label: "Worldview-1", value: "worldview-01" });
        sensors.forEach((sensor) => {
          if (!this.select.query.platform.in.includes(sensor.value)) {
            sensors = sensors.filter((item) => item.value !== sensor.value);
          }
        });
        return sensors;
      } else {
        return this.defaultModel.sensors;
      }
    },

    getImageCategories() {
      if (this.select?.image_age_category) {
        var categories = [
          { label: "Fresh", value: "fresh" },
          { label: "Standard", value: "standard" },
          { label: "Training", value: "training" },
        ];
        categories.forEach((category) => {
          if (!this.select.image_age_category.includes(category.value)) {
            categories = categories.filter(
              (item) => item.value !== category.value
            );
          }
        });
        return categories;
      } else {
        return this.defaultModel.imageCategories;
      }
    },

    getCollectYearsBetween() {
      if (this.select?.datetime) {
        try {
          const startYear = this.select?.datetime.split("/")[0];
          const endYear = this.select?.datetime.split("/")[1];

          // make sure it's not a string or date, if it's a number we are good
          const start =
            startYear != ".." && !isNaN(startYear) ? parseInt(startYear) : null;

          // make sure it's not a string or date, if it's a number we are good
          const end =
            endYear != ".." && !isNaN(endYear) ? parseInt(endYear) : null;

          if (start || end) {
            return {
              enabled: true,
              start,
              end,
            };
          }
        } catch (err) {
          console.error(err);
        }
      }

      return null;
    },

    getCollectDaysBetween() {
      if (
        this.select?.query.collect_day &&
        this.select?.query.collect_day.between
      ) {
        try {
          return {
            start: parseInt(this.select?.query.collect_day.between[0]),
            end: parseInt(this.select?.query.collect_day.between[1]),
          };
        } catch (err) {
          console.error(err);
        }
      }

      return null;
    },

    getCollectMonthDayBetween() {
      if (
        this.select?.query.collect_month_day &&
        this.select?.query.collect_month_day.between
      ) {
        try {
          const startDate =
            this.select?.query.collect_month_day.between[0].split("/");
          const endDate =
            this.select?.query.collect_month_day.between[1].split("/");
          return {
            start: {
              month: startDate[0],
              date: startDate[1],
            },
            end: {
              month: endDate[0],
              date: endDate[1],
            },
          };
        } catch (err) {
          console.error(err);
        }
      }

      return null;
    },

    getCollectMonthDayOr() {
      if (
        this.select?.query.collect_month_day &&
        this.select?.query.collect_month_day.or
      ) {
        try {
          const or = this.select?.query.collect_month_day.or;
          const gt = or.find((item) => {
            if (item["gt"]) {
              return item;
            }
          });
          const lt = or.find((item) => {
            if (item["lt"]) {
              return item;
            }
          });

          const firstDate = lt.lt.split("-");
          const secondDate = gt.gt.split("-");

          return {
            lt: {
              month: firstDate[0],
              date: firstDate[1],
            },
            gt: {
              month: secondDate[0],
              date: secondDate[1],
            },
          };
        } catch (err) {
          console.error(err);
        }
      }

      return null;
    },

    getCollectMonths() {
      if (
        this.select?.query.collect_month &&
        this.select?.query.collect_month.in
      ) {
        let months = [
          { label: "January", value: "01" },
          { label: "February", value: "02" },
          { label: "March", value: "03" },
          { label: "April", value: "04" },
          { label: "May", value: "05" },
          { label: "June", value: "06" },
          { label: "July", value: "07" },
          { label: "August", value: "08" },
          { label: "September", value: "09" },
          { label: "October", value: "10" },
          { label: "November", value: "11" },
          { label: "December", value: "12" },
        ];

        months.forEach((month) => {
          if (!this.select?.query.collect_month.in.includes(month.value)) {
            months = months.filter((item) => item.value !== month.value);
          }
        });
        return months;
      }

      return null;
    },

    convertToDate(month, date) {
      const d = new Date();

      if (parseInt(month) > 0 && parseInt(date) > 0) {
        d.setMonth(parseInt(month) - 1);
        d.setDate(parseInt(date));
      } else {
        return null;
      }

      return d;
    },

    isValidDateRange(between) {
      return (
        _.get(between, "start.month", null) &&
        _.get(between, "start.date", null) &&
        _.get(between, "end.month", null) &&
        _.get(between, "end.date", null)
      );
    },

    isValidBeforeAfter(or) {
      return (
        _.get(or, "lt.month", null) &&
        _.get(or, "lt.date", null) &&
        _.get(or, "gt.month", null) &&
        _.get(or, "gt.date", null)
      );
    },

    isValidDaysBetween(days_between) {
      return (
        _.get(days_between, "start", null) && _.get(days_between, "end", null)
      );
    },

    isValidYearsBetween(years_between) {
      return (
        _.get(years_between, "start", null) || _.get(years_between, "end", null)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* changes the icon of a datetime calendar from black to white */
.theme--dark ::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
</style>
